<template>
  <div class="conteudo-erro">
    <div class="imagem-erro mt-5">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M46 24.0563C46 3.82186 29.2277 2.11895 24.9203 2.01878C24.4132 2.00626 23.8247 2 23.2612 2H22.8355C18.4217 2.03756 2 3.55265 2 23.9311C2 44.3347 18.572 45.9311 22.992 45.9937C23.2174 46 23.4491 46 23.6807 46C24.144 46 24.6073 45.9937 25.008 45.9875C29.2089 45.9124 46 44.3347 46 24.0563ZM44.1656 24.0563C44.1656 42.3751 29.4718 44.0717 24.9704 44.1531C24.7078 44.1616 24.4164 44.1643 24.1159 44.1671C23.9725 44.1685 23.8262 44.1699 23.6807 44.1719L23.0233 44.1656C21.1013 44.1406 16.1616 43.7775 11.8167 41.0415C6.5202 37.6983 3.83438 31.9511 3.83438 23.9311C3.83438 15.9237 6.4889 10.189 11.7353 6.88958C16.0427 4.17871 20.9448 3.85316 22.8543 3.83438H23.2612C23.8122 3.83438 24.3819 3.84064 24.8765 3.85316C26.7985 3.90324 31.7319 4.30393 36.1019 7.0461C41.4548 10.4018 44.1656 16.1241 44.1656 24.0563ZM23.9937 31.3563C23.4866 31.3563 23.0797 30.9431 23.0797 30.4422V11.4474C23.0797 10.9402 23.4929 10.5333 23.9937 10.5333C24.4946 10.5333 24.9078 10.9465 24.9078 11.4474V30.4422C24.9078 30.9493 24.4946 31.3563 23.9937 31.3563ZM25.4337 35.1252C25.4337 34.3301 24.7888 33.6915 24 33.6915C23.2112 33.6915 22.5726 34.3301 22.5663 35.1252C22.5663 35.9141 23.2112 36.5589 24 36.5589C24.7951 36.5589 25.4337 35.9141 25.4337 35.1252Z" fill="#CC1F59"/>
      </svg>
    </div>

    <div class="textos mt-5">
      <p v-if="this.title" class="titulo">{{this.title}}</p>
      <p v-if="this.subtitle" class="txt-subtitulo texto-cinza">{{this.subtitle}}</p>
    </div>

    <div id="footer" v-if="this.callback">
      <button type="button" v-on:click="callback()" class="btn btn-primary btn-lg btn-block">{{this.buttonText}}</button>
      <button v-if="secoundButtonText" type="button"  v-on:click="secoundButtonCallback()" class="btn btn-link btn-lg btn-block mt-3">{{secoundButtonText}}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error",
  props:{
    title: {type: String} ,
    subtitle: {type: String},
    buttonText: {type: String},
    secoundButtonText:{Type:String},
    secoundButtonCallback:{type: Function},
    callback: {type: Function}
  },
}
</script>

<style scoped>

p.titulo{
  color: var(--text-text-primary, #000);
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}
p.subtitulo{
  color: var(--text-text-secondary, #666);
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Error.vue